import React from "react";
import { ArrowUpRight } from "lucide-react";

export const KPICard = ({ label, value, sublabel, accent, icon: Icon, testId }) => {
  return (
    <div
      className="border border-zinc-200 bg-white p-5 transition-all hover:border-zinc-900 hover:-translate-y-px"
      data-testid={testId}
    >
      <div className="flex items-start justify-between">
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">
          {label}
        </div>
        {Icon ? <Icon size={14} className="text-zinc-400" /> : <ArrowUpRight size={14} className="text-zinc-400" />}
      </div>
      <div
        className="mt-3 text-4xl font-bold font-[Chivo] tracking-tight leading-none"
        style={{ color: accent || "#0A0A0A" }}
      >
        {value}
      </div>
      {sublabel && (
        <div className="mt-2 text-xs text-zinc-500">{sublabel}</div>
      )}
    </div>
  );
};
